import me, { useCallback as kt, useState as S, useEffect as A } from "react";
import { OidcClient as d, getParseQueryStringFromLocation as Et, getPath as J, OidcLocation as Ye, getFetchDefault as Tt } from "@axa-fr/oidc-client";
import { OidcClient as or, OidcLocation as sr, TokenAutomaticRenewMode as ar, TokenRenewMode as ir } from "@axa-fr/oidc-client";
var be = { exports: {} }, K = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function wt() {
  if ($e)
    return K;
  $e = 1;
  var o = me, a = Symbol.for("react.element"), r = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, c = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(u, v, y) {
    var b, k = {}, C = null, x = null;
    y !== void 0 && (C = "" + y), v.key !== void 0 && (C = "" + v.key), v.ref !== void 0 && (x = v.ref);
    for (b in v)
      s.call(v, b) && !l.hasOwnProperty(b) && (k[b] = v[b]);
    if (u && u.defaultProps)
      for (b in v = u.defaultProps, v)
        k[b] === void 0 && (k[b] = v[b]);
    return { $$typeof: a, type: u, key: C, ref: x, props: k, _owner: c.current };
  }
  return K.Fragment = r, K.jsx = _, K.jsxs = _, K;
}
var H = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function Ot() {
  return Ve || (Ve = 1, process.env.NODE_ENV !== "production" && function() {
    var o = me, a = Symbol.for("react.element"), r = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), F = Symbol.iterator, V = "@@iterator";
    function Y(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = F && e[F] || e[V];
      return typeof t == "function" ? t : null;
    }
    var U = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), f = 1; f < t; f++)
          n[f - 1] = arguments[f];
        ne("error", e, n);
      }
    }
    function ne(e, t, n) {
      {
        var f = U.ReactDebugCurrentFrame, g = f.getStackAddendum();
        g !== "" && (t += "%s", n = n.concat([g]));
        var m = n.map(function(p) {
          return String(p);
        });
        m.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var $ = !1, oe = !1, se = !1, ae = !1, ie = !1, I;
    I = Symbol.for("react.module.reference");
    function ce(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === s || e === l || ie || e === c || e === y || e === b || ae || e === x || $ || oe || se || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === k || e.$$typeof === _ || e.$$typeof === u || e.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === I || e.getModuleId !== void 0));
    }
    function le(e, t, n) {
      var f = e.displayName;
      if (f)
        return f;
      var g = t.displayName || t.name || "";
      return g !== "" ? n + "(" + g + ")" : n;
    }
    function W(e) {
      return e.displayName || "Context";
    }
    function j(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case s:
          return "Fragment";
        case r:
          return "Portal";
        case l:
          return "Profiler";
        case c:
          return "StrictMode";
        case y:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case u:
            var t = e;
            return W(t) + ".Consumer";
          case _:
            var n = e;
            return W(n._context) + ".Provider";
          case v:
            return le(e, e.render, "ForwardRef");
          case k:
            var f = e.displayName || null;
            return f !== null ? f : j(e.type) || "Memo";
          case C: {
            var g = e, m = g._payload, p = g._init;
            try {
              return j(p(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, D = 0, q, T, N, Ee, Te, we, Oe;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function He() {
      {
        if (D === 0) {
          q = console.log, T = console.info, N = console.warn, Ee = console.error, Te = console.group, we = console.groupCollapsed, Oe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        D++;
      }
    }
    function Xe() {
      {
        if (D--, D === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, e, {
              value: q
            }),
            info: M({}, e, {
              value: T
            }),
            warn: M({}, e, {
              value: N
            }),
            error: M({}, e, {
              value: Ee
            }),
            group: M({}, e, {
              value: Te
            }),
            groupCollapsed: M({}, e, {
              value: we
            }),
            groupEnd: M({}, e, {
              value: Oe
            })
          });
        }
        D < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ue = U.ReactCurrentDispatcher, de;
    function Q(e, t, n) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (g) {
            var f = g.stack.trim().match(/\n( *(at )?)/);
            de = f && f[1] || "";
          }
        return `
` + de + e;
      }
    }
    var fe = !1, Z;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Z = new Qe();
    }
    function Re(e, t) {
      if (!e || fe)
        return "";
      {
        var n = Z.get(e);
        if (n !== void 0)
          return n;
      }
      var f;
      fe = !0;
      var g = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = ue.current, ue.current = null, He();
      try {
        if (t) {
          var p = function() {
            throw Error();
          };
          if (Object.defineProperty(p.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(p, []);
            } catch (L) {
              f = L;
            }
            Reflect.construct(e, [], p);
          } else {
            try {
              p.call();
            } catch (L) {
              f = L;
            }
            e.call(p.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (L) {
            f = L;
          }
          e();
        }
      } catch (L) {
        if (L && f && typeof L.stack == "string") {
          for (var h = L.stack.split(`
`), R = f.stack.split(`
`), E = h.length - 1, w = R.length - 1; E >= 1 && w >= 0 && h[E] !== R[w]; )
            w--;
          for (; E >= 1 && w >= 0; E--, w--)
            if (h[E] !== R[w]) {
              if (E !== 1 || w !== 1)
                do
                  if (E--, w--, w < 0 || h[E] !== R[w]) {
                    var P = `
` + h[E].replace(" at new ", " at ");
                    return e.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", e.displayName)), typeof e == "function" && Z.set(e, P), P;
                  }
                while (E >= 1 && w >= 0);
              break;
            }
        }
      } finally {
        fe = !1, ue.current = m, Xe(), Error.prepareStackTrace = g;
      }
      var z = e ? e.displayName || e.name : "", Me = z ? Q(z) : "";
      return typeof e == "function" && Z.set(e, Me), Me;
    }
    function Ze(e, t, n) {
      return Re(e, !1);
    }
    function et(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function ee(e, t, n) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Re(e, et(e));
      if (typeof e == "string")
        return Q(e);
      switch (e) {
        case y:
          return Q("Suspense");
        case b:
          return Q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            return Ze(e.render);
          case k:
            return ee(e.type, t, n);
          case C: {
            var f = e, g = f._payload, m = f._init;
            try {
              return ee(m(g), t, n);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, xe = {}, je = U.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var t = e._owner, n = ee(e.type, e._source, t ? t.type : null);
        je.setExtraStackFrame(n);
      } else
        je.setExtraStackFrame(null);
    }
    function tt(e, t, n, f, g) {
      {
        var m = Function.call.bind(te);
        for (var p in e)
          if (m(e, p)) {
            var h = void 0;
            try {
              if (typeof e[p] != "function") {
                var R = Error((f || "React class") + ": " + n + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              h = e[p](t, p, f, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              h = E;
            }
            h && !(h instanceof Error) && (re(g), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", n, p, typeof h), re(null)), h instanceof Error && !(h.message in xe) && (xe[h.message] = !0, re(g), O("Failed %s type: %s", n, h.message), re(null));
          }
      }
    }
    var rt = Array.isArray;
    function ve(e) {
      return rt(e);
    }
    function nt(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, n = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }
    function ot(e) {
      try {
        return Pe(e), !1;
      } catch {
        return !0;
      }
    }
    function Pe(e) {
      return "" + e;
    }
    function Se(e) {
      if (ot(e))
        return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nt(e)), Pe(e);
    }
    var G = U.ReactCurrentOwner, st = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ae, Fe, he;
    he = {};
    function at(e) {
      if (te.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function it(e) {
      if (te.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function ct(e, t) {
      if (typeof e.ref == "string" && G.current && t && G.current.stateNode !== t) {
        var n = j(G.current.type);
        he[n] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(G.current.type), e.ref), he[n] = !0);
      }
    }
    function lt(e, t) {
      {
        var n = function() {
          Ae || (Ae = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function ut(e, t) {
      {
        var n = function() {
          Fe || (Fe = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var dt = function(e, t, n, f, g, m, p) {
      var h = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: a,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: n,
        props: p,
        // Record the component responsible for creating this element.
        _owner: m
      };
      return h._store = {}, Object.defineProperty(h._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(h, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(h, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.freeze && (Object.freeze(h.props), Object.freeze(h)), h;
    };
    function ft(e, t, n, f, g) {
      {
        var m, p = {}, h = null, R = null;
        n !== void 0 && (Se(n), h = "" + n), it(t) && (Se(t.key), h = "" + t.key), at(t) && (R = t.ref, ct(t, g));
        for (m in t)
          te.call(t, m) && !st.hasOwnProperty(m) && (p[m] = t[m]);
        if (e && e.defaultProps) {
          var E = e.defaultProps;
          for (m in E)
            p[m] === void 0 && (p[m] = E[m]);
        }
        if (h || R) {
          var w = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          h && lt(p, w), R && ut(p, w);
        }
        return dt(e, h, R, g, f, G.current, p);
      }
    }
    var pe = U.ReactCurrentOwner, Ie = U.ReactDebugCurrentFrame;
    function B(e) {
      if (e) {
        var t = e._owner, n = ee(e.type, e._source, t ? t.type : null);
        Ie.setExtraStackFrame(n);
      } else
        Ie.setExtraStackFrame(null);
    }
    var _e;
    _e = !1;
    function ge(e) {
      return typeof e == "object" && e !== null && e.$$typeof === a;
    }
    function De() {
      {
        if (pe.current) {
          var e = j(pe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function vt(e) {
      {
        if (e !== void 0) {
          var t = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
          return `

Check your code at ` + t + ":" + n + ".";
        }
        return "";
      }
    }
    var Ne = {};
    function ht(e) {
      {
        var t = De();
        if (!t) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (t = `

Check the top-level render call using <` + n + ">.");
        }
        return t;
      }
    }
    function Le(e, t) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var n = ht(t);
        if (Ne[n])
          return;
        Ne[n] = !0;
        var f = "";
        e && e._owner && e._owner !== pe.current && (f = " It was passed a child from " + j(e._owner.type) + "."), B(e), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, f), B(null);
      }
    }
    function Ue(e, t) {
      {
        if (typeof e != "object")
          return;
        if (ve(e))
          for (var n = 0; n < e.length; n++) {
            var f = e[n];
            ge(f) && Le(f, t);
          }
        else if (ge(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var g = Y(e);
          if (typeof g == "function" && g !== e.entries)
            for (var m = g.call(e), p; !(p = m.next()).done; )
              ge(p.value) && Le(p.value, t);
        }
      }
    }
    function pt(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var n;
        if (typeof t == "function")
          n = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === k))
          n = t.propTypes;
        else
          return;
        if (n) {
          var f = j(t);
          tt(n, e.props, "prop", f, e);
        } else if (t.PropTypes !== void 0 && !_e) {
          _e = !0;
          var g = j(t);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", g || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function _t(e) {
      {
        for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
          var f = t[n];
          if (f !== "children" && f !== "key") {
            B(e), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), B(null);
            break;
          }
        }
        e.ref !== null && (B(e), O("Invalid attribute `ref` supplied to `React.Fragment`."), B(null));
      }
    }
    function We(e, t, n, f, g, m) {
      {
        var p = ce(e);
        if (!p) {
          var h = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (h += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = vt(g);
          R ? h += R : h += De();
          var E;
          e === null ? E = "null" : ve(e) ? E = "array" : e !== void 0 && e.$$typeof === a ? (E = "<" + (j(e.type) || "Unknown") + " />", h = " Did you accidentally export a JSX literal instead of a component?") : E = typeof e, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, h);
        }
        var w = ft(e, t, n, g, m);
        if (w == null)
          return w;
        if (p) {
          var P = t.children;
          if (P !== void 0)
            if (f)
              if (ve(P)) {
                for (var z = 0; z < P.length; z++)
                  Ue(P[z], e);
                Object.freeze && Object.freeze(P);
              } else
                O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ue(P, e);
        }
        return e === s ? _t(w) : pt(w), w;
      }
    }
    function gt(e, t, n) {
      return We(e, t, n, !0);
    }
    function yt(e, t, n) {
      return We(e, t, n, !1);
    }
    var bt = yt, mt = gt;
    H.Fragment = s, H.jsx = bt, H.jsxs = mt;
  }()), H;
}
process.env.NODE_ENV === "production" ? be.exports = wt() : be.exports = Ot();
var i = be.exports;
const Be = "default", Ct = (o, a, r = !1) => async (...s) => await a().fetchWithTokens(o, r)(...s), Kt = (o = null, a = Be, r = !1) => (s) => (c) => {
  const { fetch: l } = Rt(o || c.fetch, a, r);
  return /* @__PURE__ */ i.jsx(s, { ...c, fetch: l });
}, Rt = (o = null, a = Be, r = !1) => {
  const s = o || window.fetch, c = d.get;
  return { fetch: kt(
    (_, u) => Ct(s, () => c(a), r)(_, u),
    [s, a]
  ) };
}, ze = () => /* @__PURE__ */ i.jsx("div", { className: "oidc-authenticating", children: /* @__PURE__ */ i.jsxs("div", { className: "oidc-authenticating__container", children: [
  /* @__PURE__ */ i.jsx("h1", { className: "oidc-authenticating__title", children: "Error authentication" }),
  /* @__PURE__ */ i.jsx("p", { className: "oidc-authenticating__content", children: "An error occurred during authentication." })
] }) }), xt = () => /* @__PURE__ */ i.jsx("div", { className: "oidc-authenticating", children: /* @__PURE__ */ i.jsxs("div", { className: "oidc-authenticating__container", children: [
  /* @__PURE__ */ i.jsx("h1", { className: "oidc-authenticating__title", children: "Authentication in progress" }),
  /* @__PURE__ */ i.jsx("p", { className: "oidc-authenticating__content", children: "You will be redirected to the login page." })
] }) }), jt = () => Math.random().toString(36).substr(2, 6), Pt = (o, a) => (r, s) => {
  if (typeof o.CustomEvent == "function")
    return new o.CustomEvent(r, s);
  const c = s || { bubbles: !1, cancelable: !1, detail: void 0 }, l = a.createEvent("CustomEvent");
  return l.initCustomEvent(r, c.bubbles, c.cancelable, c.detail), l.prototype = o.Event.prototype, l;
}, St = (o, a, r) => ({
  replaceState: (s, c) => {
    const l = r(), _ = c || o.history.state;
    o.history.replaceState({ key: l, state: _ }, null, s), o.dispatchEvent(a("popstate"));
  }
}), At = () => St(window, Pt(window, document), jt), Ge = () => /* @__PURE__ */ i.jsx("div", { className: "oidc-callback", children: /* @__PURE__ */ i.jsxs("div", { className: "oidc-callback__container", children: [
  /* @__PURE__ */ i.jsx("h1", { className: "oidc-callback__title", children: "Authentication complete" }),
  /* @__PURE__ */ i.jsx("p", { className: "oidc-callback__content", children: "You will be redirected to your application." })
] }) }), Ft = ({ callBackError: o, callBackSuccess: a, configurationName: r, withCustomHistory: s }) => {
  const [c, l] = S(!1);
  A(() => {
    let v = !0;
    return (async () => {
      const b = d.get;
      try {
        const { callbackPath: k } = await b(r).loginCallbackAsync();
        (s ? s() : At()).replaceState(k || "/");
      } catch (k) {
        v && (console.warn(k), l(!0));
      }
    })(), () => {
      v = !1;
    };
  }, []);
  const _ = o || ze, u = a || Ge;
  return c ? /* @__PURE__ */ i.jsx(_, { configurationName: r }) : /* @__PURE__ */ i.jsx(u, { configurationName: r });
}, It = () => /* @__PURE__ */ i.jsx("span", { className: "oidc-loading", children: "Loading" }), Dt = () => /* @__PURE__ */ i.jsx("div", { className: "oidc-serviceworker", children: /* @__PURE__ */ i.jsxs("div", { className: "oidc-serviceworker__container", children: [
  /* @__PURE__ */ i.jsx("h1", { className: "oidc-serviceworker__title", children: "Unable to authenticate on this browser" }),
  /* @__PURE__ */ i.jsx("p", { className: "oidc-serviceworker__content", children: "Your browser is not secure enough to make authentication work. Try updating your browser or use a newer browser." })
] }) }), Nt = () => /* @__PURE__ */ i.jsx("div", { className: "oidc-session-lost", children: /* @__PURE__ */ i.jsxs("div", { className: "oidc-session-lost__container", children: [
  /* @__PURE__ */ i.jsx("h1", { className: "oidc-session-lost__title", children: "Session timed out" }),
  /* @__PURE__ */ i.jsx("p", { className: "oidc-session-lost__content", children: "Your session has expired. Please re-authenticate." })
] }) }), Lt = ({ configurationName: o }) => (A(() => {
  (async () => {
    const r = d.get;
    r(o).silentLoginCallbackAsync();
  })();
}, []), /* @__PURE__ */ i.jsx(i.Fragment, {})), Ut = ({ configurationName: o }) => {
  const a = Et(window.location.href), r = d.get, s = r(o);
  let c = null;
  for (const [l, _] of Object.entries(a))
    l === "state" || l === "scope" || (c === null && (c = {}), c[l] = _);
  return A(() => {
    s.tokens || s.loginAsync(null, c, !0, a.scope);
  }, []), /* @__PURE__ */ i.jsx(i.Fragment, {});
}, Wt = ({
  callbackErrorComponent: o,
  callbackSuccessComponent: a,
  redirect_uri: r,
  silent_redirect_uri: s,
  silent_login_uri: c,
  children: l,
  configurationName: _,
  withCustomHistory: u = null,
  location: v
}) => {
  const y = window ? J(window.location.href) : "", [b, k] = S(y);
  A(() => {
    const x = () => k(J(window.location.href));
    return x(), window.addEventListener("popstate", x, !1), () => window.removeEventListener("popstate", x, !1);
  }, []);
  const C = J(r);
  if (s && b === J(s))
    return /* @__PURE__ */ i.jsx(Lt, { configurationName: _ });
  if (c && b === J(c))
    return /* @__PURE__ */ i.jsx(Ut, { configurationName: _ });
  switch (b) {
    case C:
      return /* @__PURE__ */ i.jsx(Ft, { callBackError: o, callBackSuccess: a, configurationName: _, withCustomHistory: u });
    default:
      return /* @__PURE__ */ i.jsx(i.Fragment, { children: l });
  }
}, Mt = me.memo(Wt), qe = { name: "", data: null }, Yt = ({ loadingComponent: o, children: a, configurationName: r }) => {
  const [s, c] = S(!0), l = d.get, _ = l(r);
  A(() => {
    let v = !0;
    return _ && _.tryKeepExistingSessionAsync().then(() => {
      v && c(!1);
    }), () => {
      v = !1;
    };
  }, [r]);
  const u = o;
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: s ? /* @__PURE__ */ i.jsx(u, { configurationName: r }) : /* @__PURE__ */ i.jsx(i.Fragment, { children: a }) });
}, X = ({ isLoading: o, loadingComponent: a, children: r, configurationName: s }) => {
  const c = a;
  return o ? /* @__PURE__ */ i.jsx(c, { configurationName: s, children: r }) : /* @__PURE__ */ i.jsx(i.Fragment, { children: r });
}, Ht = ({
  children: o,
  configuration: a,
  configurationName: r = "default",
  callbackSuccessComponent: s = Ge,
  authenticatingComponent: c = xt,
  loadingComponent: l = It,
  serviceWorkerNotSupportedComponent: _ = Dt,
  authenticatingErrorComponent: u = ze,
  sessionLostComponent: v = Nt,
  onSessionLost: y = null,
  onLogoutFromAnotherTab: b = null,
  onLogoutFromSameTab: k = null,
  withCustomHistory: C = null,
  onEvent: x = null,
  getFetch: F = null,
  location: V = null
}) => {
  const Y = (D = "default") => d.getOrCreate(F ?? Tt, V ?? new Ye())(a, D), [U, O] = S(!0), [ne, $] = S(qe), [oe, se] = S("default");
  A(() => {
    const q = Y(r).subscribeEvents((T, N) => {
      x && x(r, T, N);
    });
    return () => {
      Y(r).removeEventSubscription(q);
    };
  }, [r, x]), A(() => {
    const q = Y(r).subscribeEvents((T, N) => {
      if (T === d.eventNames.refreshTokensAsync_error || T === d.eventNames.syncTokensAsync_error) {
        if (y != null) {
          y();
          return;
        }
        $({ name: T, data: N });
      } else if (T === d.eventNames.logout_from_another_tab) {
        if (b != null) {
          b();
          return;
        }
        $({ name: T, data: N });
      } else
        T === d.eventNames.logout_from_same_tab ? k != null && k() : T === d.eventNames.loginAsync_begin || T === d.eventNames.loginCallbackAsync_end || T === d.eventNames.loginAsync_error || T === d.eventNames.loginCallbackAsync_error ? $({ name: T, data: N }) : T === d.eventNames.service_worker_not_supported_by_browser && a.service_worker_only === !0 && $({ name: T, data: N });
    });
    return se(r), O(!1), () => {
      Y(r).removeEventSubscription(q), $(qe);
    };
  }, [a, r]);
  const ae = v, ie = c, I = l, ce = _, le = u, W = U || oe !== r, j = Y(r);
  switch (ne.name) {
    case d.eventNames.service_worker_not_supported_by_browser:
      return /* @__PURE__ */ i.jsx(X, { loadingComponent: I, isLoading: W, configurationName: r, children: /* @__PURE__ */ i.jsx(ce, { configurationName: r }) });
    case d.eventNames.loginAsync_begin:
      return /* @__PURE__ */ i.jsx(X, { loadingComponent: I, isLoading: W, configurationName: r, children: /* @__PURE__ */ i.jsx(ie, { configurationName: r }) });
    case d.eventNames.loginAsync_error:
    case d.eventNames.loginCallbackAsync_error:
      return /* @__PURE__ */ i.jsx(X, { loadingComponent: I, isLoading: W, configurationName: r, children: /* @__PURE__ */ i.jsx(le, { configurationName: r }) });
    case d.eventNames.refreshTokensAsync_error:
    case d.eventNames.syncTokensAsync_error:
    case d.eventNames.logout_from_another_tab:
      return /* @__PURE__ */ i.jsx(X, { loadingComponent: I, isLoading: W, configurationName: r, children: /* @__PURE__ */ i.jsx(ae, { configurationName: r }) });
    default:
      return /* @__PURE__ */ i.jsx(X, { loadingComponent: I, isLoading: W, configurationName: r, children: /* @__PURE__ */ i.jsx(
        Mt,
        {
          redirect_uri: j.configuration.redirect_uri,
          silent_redirect_uri: j.configuration.silent_redirect_uri,
          silent_login_uri: j.configuration.silent_login_uri,
          callbackSuccessComponent: s,
          callbackErrorComponent: u,
          authenticatingComponent: c,
          configurationName: r,
          withCustomHistory: C,
          location: V ?? new Ye(),
          children: /* @__PURE__ */ i.jsx(Yt, { loadingComponent: I, configurationName: r, children: o })
        }
      ) });
  }
}, $t = ({ children: o, callbackPath: a = null, extras: r = null, configurationName: s = "default" }) => {
  const c = d.get, l = c(s);
  return A(() => {
    l.tokens || l.loginAsync(a, r);
  }, [s, a, r]), l.tokens ? /* @__PURE__ */ i.jsx(i.Fragment, { children: o }) : null;
}, Xt = (o, a = null, r = null, s = "default") => (c) => /* @__PURE__ */ i.jsx($t, { callbackPath: a, extras: r, configurationName: s, children: /* @__PURE__ */ i.jsx(o, { ...c }) }), ke = "default", ye = (o, a) => {
  let r = !1;
  return o(a) && (r = o(a).tokens != null), r;
}, Qt = (o = ke) => {
  const a = d.get, [r, s] = S(ye(a, o));
  return A(() => {
    let u = !0;
    const v = a(o);
    s(ye(a, o));
    const y = v.subscribeEvents((b, k) => {
      (b === d.eventNames.logout_from_another_tab || b === d.eventNames.logout_from_same_tab || b === d.eventNames.token_aquired) && u && s(ye(a, o));
    });
    return () => {
      u = !1, v.removeEventSubscription(y);
    };
  }, [o]), { login: (u = void 0, v = null, y = !1) => a(o).loginAsync(u, v, !1, void 0, y), logout: (u = void 0, v = null) => a(o).logoutAsync(u, v), renewTokens: async (u = null) => {
    const v = await a(o).renewTokensAsync(u);
    return {
      // @ts-ignore
      accessToken: v.accessToken,
      // @ts-ignore
      accessTokenPayload: v.accessTokenPayload,
      // @ts-ignore
      idToken: v.idToken,
      // @ts-ignore
      idTokenPayload: v.idTokenPayload
    };
  }, isAuthenticated: r };
}, Je = { accessToken: null, accessTokenPayload: null }, Vt = (o) => {
  const a = d.get, r = a(o);
  if (r.tokens) {
    const s = r.tokens;
    return {
      accessToken: s.accessToken,
      accessTokenPayload: s.accessTokenPayload,
      generateDemonstrationOfProofOfPossessionAsync: r.configuration.demonstrating_proof_of_possession ? (c, l) => r.generateDemonstrationOfProofOfPossessionAsync(s.accessToken, c, l) : null
    };
  }
  return Je;
};
function qt(o, a) {
  return o.configuration.demonstrating_proof_of_possession ? (r, s, c = {}) => o.generateDemonstrationOfProofOfPossessionAsync(a.accessToken, r, s, c) : null;
}
const Zt = (o = ke) => {
  const a = d.get, [r, s] = S(Vt(o));
  return A(() => {
    let c = !0;
    const l = a(o);
    if (l.tokens) {
      const u = l.tokens;
      s({ accessToken: u.accessToken, accessTokenPayload: u.accessTokenPayload });
    }
    const _ = l.subscribeEvents((u, v) => {
      if ((u === d.eventNames.token_renewed || u === d.eventNames.token_aquired || u === d.eventNames.logout_from_another_tab || u === d.eventNames.logout_from_same_tab || u === d.eventNames.refreshTokensAsync_error || u === d.eventNames.syncTokensAsync_error) && c) {
        const y = l.tokens;
        s(y != null ? {
          accessToken: y.accessToken,
          accessTokenPayload: y.accessTokenPayload,
          generateDemonstrationOfProofOfPossessionAsync: qt(l, y)
        } : Je);
      }
    });
    return () => {
      c = !1, l.removeEventSubscription(_);
    };
  }, [o]), r;
}, Ke = { idToken: null, idTokenPayload: null }, Bt = (o) => {
  const a = d.get, r = a(o);
  if (r.tokens) {
    const s = r.tokens;
    return { idToken: s.idToken, idTokenPayload: s.idTokenPayload };
  }
  return Ke;
}, er = (o = ke) => {
  const a = d.get, [r, s] = S(Bt(o));
  return A(() => {
    let c = !0;
    const l = a(o);
    if (l.tokens) {
      const u = l.tokens;
      s({ idToken: u.idToken, idTokenPayload: u.idTokenPayload });
    }
    const _ = l.subscribeEvents((u, v) => {
      if ((u === d.eventNames.token_renewed || u === d.eventNames.token_aquired || u === d.eventNames.logout_from_another_tab || u === d.eventNames.logout_from_same_tab || u === d.eventNames.refreshTokensAsync_error || u === d.eventNames.syncTokensAsync_error) && c) {
        const y = l.tokens;
        s(y != null ? { idToken: y.idToken, idTokenPayload: y.idTokenPayload } : Ke);
      }
    });
    return () => {
      c = !1, l.removeEventSubscription(_);
    };
  }, [o]), r;
};
var zt = /* @__PURE__ */ ((o) => (o.Unauthenticated = "Unauthenticated", o.Loading = "Loading user", o.Loaded = "User loaded", o.LoadingError = "Error loading user", o))(zt || {});
const tr = (o = "default", a = !1) => {
  const s = d.get(o).userInfo(), [c, l] = S({
    user: s,
    status: s ? "User loaded" : "Unauthenticated"
    /* Unauthenticated */
  }), [_, u] = S(s ? 1 : 0), [v, y] = S(s ? 1 : 0);
  A(() => {
    const k = d.get(o);
    let C = !0;
    if (k && k.tokens) {
      const F = _ === v;
      if (F && k.userInfo())
        return;
      l({
        ...c,
        status: "Loading user"
        /* Loading */
      }), k.userInfoAsync(!F, a).then((V) => {
        C && l({
          user: V,
          status: "User loaded"
          /* Loaded */
        });
      }).catch(() => l({
        ...c,
        status: "Error loading user"
        /* LoadingError */
      })), y(_);
    } else
      l({
        user: null,
        status: "Unauthenticated"
        /* Unauthenticated */
      });
    const x = k.subscribeEvents((F) => {
      (F === d.eventNames.logout_from_another_tab || F === d.eventNames.logout_from_same_tab) && C && l({
        user: null,
        status: "Unauthenticated"
        /* Unauthenticated */
      });
    });
    return () => {
      C = !1, k.removeEventSubscription(x);
    };
  }, [_]);
  const b = () => {
    u(_ + 1);
  };
  return { oidcUser: c.user, oidcUserLoadingState: c.status, reloadOidcUser: b };
};
export {
  or as OidcClient,
  sr as OidcLocation,
  Ht as OidcProvider,
  $t as OidcSecure,
  zt as OidcUserStatus,
  ar as TokenAutomaticRenewMode,
  ir as TokenRenewMode,
  Qt as useOidc,
  Zt as useOidcAccessToken,
  Rt as useOidcFetch,
  er as useOidcIdToken,
  tr as useOidcUser,
  Kt as withOidcFetch,
  Xt as withOidcSecure
};
